/**
 * Takes a string and returns the same string in lowercase format
 * with dashes replacing spaces.
 * @param  {string} string
 * @return {string}
 */
const slugifyString = (string) => {
  const lowerCaseString = String(string).toLowerCase();
  const lowerCaseStringWithDashes = lowerCaseString?.split(" ").join("-");
  return lowerCaseStringWithDashes;
};
export default slugifyString;
